import { ProjectStatus } from '@nx-customer-apps/shared/enums';

export const isReadOnly = (projectStatus: ProjectStatus, options?: { excludeMigrated?: boolean }): boolean => {
    const statuses = [ProjectStatus.Closed, ProjectStatus.Archived];
    if (!options?.excludeMigrated) {
        statuses.push(...[ProjectStatus.Migrated, ProjectStatus.MigratedClosed]);
    }
    return statuses.includes(projectStatus);
};
